import { useEffect, useRef } from "react"
import { Thumbnail } from "react-pdf"
import { modifiers } from "ui-tools"
import { usePDFContext } from "../../providers"
import s from "./Outline.module.scss"

export const Outline = () => {
  // Outline should handle its own visibility using the "display" CSS property.
  // This allows it to be toggled without unmounting/remounting the component.
  // Remounting causes all thumbnails to rerender and hinders performance.
  const { isOutlineVisible, numberOfPagesRef } = usePDFContext()

  return (
    <div className={modifiers(s, "outline", { isVisible: isOutlineVisible })}>
      {Array.from(new Array(numberOfPagesRef.current), (_, index) => (
        <PageThumbnail key={index} pageNumber={index + 1} />
      ))}
    </div>
  )
}

const PageThumbnail = ({ pageNumber }: { pageNumber: number }) => {
  const { currentPageNumber, navigateToPage } = usePDFContext()
  const ref = useRef<HTMLDivElement>(null)

  const THUMBNAIL_WIDTH = 120
  const isActive = pageNumber === currentPageNumber

  useEffect(() => {
    if (!isActive) return

    const element = ref.current

    if (!element) return

    element.scrollIntoView({
      behavior: "smooth",
      block: "center",
    })
  }, [isActive])

  return (
    <div ref={ref} className={s.outline__thumbnailContainer}>
      <Thumbnail
        className={modifiers(s, "outline__thumbnail", { isActive })}
        pageNumber={pageNumber}
        width={THUMBNAIL_WIDTH}
        onItemClick={() => navigateToPage(pageNumber)}
        aria-label={`Navigate to page ${pageNumber}`}
      />

      <div className={s.outline__pageNumber}>{pageNumber}</div>
    </div>
  )
}
